<template>
  <div class="list-view__header__arrows">
    <img
      v-if="sortingTitles === 'asc' || sortingTitles === 'default'"
      src="@/assets/images/arrow-up.svg"
      alt=""
    />
    <img
      v-if="sortingTitles === 'desc' || sortingTitles === 'default'"
      src="@/assets/images/arrow-down.svg"
      alt=""
    />
  </div>
</template>
<script>
export default {
  props: {
    sortingTitles: {
      type: String,
    },
  },
};
</script>
<style>
.list-view__header__arrows {
  @apply flex
    flex-col
    gap-1
    items-center
    justify-center;
}
</style>
